<div class="blog-top">
  <div class="container top-title">
    <div class="title">Vize Başvurusu</div>
    <div class="b-title">
      <div class="slogan">Hızlı ve Güvenilir.</div>
    </div>
  </div>
</div>
<div class="container">
  <!-- step design -->
  <div class="stepper">
    <div class="step active">
      <div class="step-number">1</div>
      <div class="step-label">Formu Doldur</div>
    </div>
    <div class="step" [ngClass]="{ active: showType >= 3 }">
      <div class="step-number">2</div>
      <div class="step-label">Fatura Bilgileri</div>
    </div>
    <div class="step" [ngClass]="{ active: showType >= 4 }">
      <div class="step-number">3</div>
      <div class="step-label">Ödeme Yap</div>
    </div>
    <div class="step" [ngClass]="{ active: showType >= 5 }">
      <div class="step-number">4</div>
      <div class="step-label">Başvuru Özeti</div>
    </div>
  </div>

  <!-- Ana Container -->
  <div class="container vehicle p0">
    <div class="row p0">
      <!-- Sol Kolon - Özet (Her zaman görünür) -->
      <div class="cars col-md-3" *ngIf="showType != showTypes.result && showType != showTypes.payment">
        <app-visa-detail [visaCountry]="selectedCountry.name" [visaType]="selectedVisaType.name" [visitReason]="selectedVisitReason.name" [total]="resultPrice"> </app-visa-detail>
      </div>
      <!-- Sağ Kolon - Dinamik İçerik -->
      <div [class]="showType != showTypes.result && showType != showTypes.payment ? 'col-md-9' : 'col-md-12'">
        <div *ngIf="showType == showTypes.firstStep" class="steps-details">
          <div *ngIf="childType > 0">
            <button (click)="childBack()"><img _ngcontent-ng-c11274661="" src="../../../assets/vectors/Group-arrow.svg" /></button>
          </div>
          <div *ngIf="childType == childTypes.country" class="details">
            <div [@slideDownUp]>
              <h2 class="title">Ülke Seçimi</h2>
              <div class="stext">Vize Başvuru Yapacağınız Ülkeyi Seçiniz</div>

              <div *ngFor="let item of visaCountries" class="col-4 col-sm-3 m-2 clickable-div" (click)="choose(item.id, 'country')">
                <div>
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="childType == childTypes.visaReason" class="details">
            <div [@slideDownUp]>
              <h2 class="title">Vize Türü Seçimi</h2>
              <div class="stext">Vize Başvurusu Sebebinizi Seçiniz</div>

              <div *ngFor="let item of visitReasons" class="col-4 col-sm-3 m-2 clickable-div" (click)="choose(item.id, 'reason')">
                <div>
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="childType == childTypes.visaType && visaTypes.length > 0" class="details">
            <div [@slideDownUp]>
              <h2 class="title">Vize Süre Seçimi</h2>
              <div class="stext">Vize Başvurusunuzun Süresini Seçiniz</div>

              <div *ngFor="let item of visaTypes" class="col-4 col-sm-3 m-2 clickable-div" (click)="choose(item.id, 'type')">
                <div>
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <input (change)="page_1_onFileSelected($event, 'passportFile_1')" type="file" #photoooInput hidden id="photooo" name="passportFile_1" [class]="'photooo' + 0" accept="image/*" />
        <div *ngIf="showType == showTypes.pasaportStep" class="application-section">
          <div class="pass-box">
            <span
              >Bilgisayarınızdan ya da telefonunuzla çektiğiniz pasaport fotoğrafını sisteme yükleyin, işlemleriniz hızlı ve güvenli bir şekilde tamamlansın. Pasaport yüklemeden önce lütfen aşağıdaki
              örnek görsele dikkat edin. Tüm bilgiler net, eksiksiz ve görünür olmalıdır.</span
            >
            <button class="mt-3 mb-3" (click)="openFileDialog('passportFile_1', 0, true)">
              <svg viewBox="64 64 896 896" data-icon="upload" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="">
                <path
                  d="M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                ></path>
              </svg>
              Pasaport Resmi Yükle ve Devam et <i class="fa fa-angle-double-right"></i>
            </button>
            <!-- <span class="mt-3 mb-3"></span> -->
            <app-pasaport-modal [className]="'clickable-container'" (click)="openFileDialog('passportFile_1', 0, true)" *ngIf="showType == showTypes.pasaportStep"></app-pasaport-modal>
          </div>
        </div>
        <form action="" [formGroup]="form">
          <!-- Step 1 - Form Alanları -->
          <div [style]="showType == showTypes.form ? 'display: block' : 'display: none'" *ngIf="showType != showTypes.payment && showType != showTypes.result" class="application-section">
            <div [@slideDownUp]>
              <div class="application-section">
                <div class="form-title">
                  <h6>Başvuru Formu</h6>
                </div>
                <div class="application-div">
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>Başvuru Türü</label>
                      <select class="form-control" formControlName="applicationType" style="background-color: transparent">
                        <ng-container *ngFor="let item of applicationTypes">
                          <option [ngValue]="item.id">{{ item.name }}</option>
                        </ng-container>
                      </select>
                      <div>
                        <small class="text-danger" *ngIf="isSubmitForm && form.controls['applicationType']?.errors?.['required']">{{ errors.required }}</small>
                      </div>
                    </div>

                    <div class="form-group col-md-4">
                      <label>Gidiş Tarihi</label>
                      <input type="date" class="form-control" formControlName="arrivalDate" style="background-color: transparent; cursor: pointer" #dateInput (click)="openDatePicker(dateInput)" />

                      <div>
                        <small class="text-danger" *ngIf="isSubmitForm && form.controls['arrivalDate']?.errors?.['required']">{{ errors.required }}</small>
                        <small class="text-danger" *ngIf="isSubmitForm && form.controls['arrivalDate']?.errors?.['dateInPast']">{{ errors.dateInPast }}</small>
                      </div>
                    </div>

                    <div class="form-group col-md-4">
                      <label>Vize Aciliyet Seviyesi</label>
                      <select class="form-control" formControlName="visaLevelId" (change)="calculatePrice()" style="background-color: transparent">
                        <ng-container *ngFor="let item of visaLevels">
                          <option [ngValue]="item.id">{{ item.name }}</option>
                        </ng-container>
                      </select>
                      <div>
                        <small class="text-danger" *ngIf="isSubmitForm && form.controls['visaLevelId']?.errors?.['min']">{{ errors.required }}</small>
                      </div>
                    </div>
                  </div>
                  <div formArrayName="customers" ngbAccordion>
                    <ng-container *ngFor="let customer of customers?.controls; index as i">
                      <div ngbAccordionItem [collapsed]="false" [formGroupName]="i">
                        <div>
                          <button class="acc-button" ngbAccordionButton>
                            <div class="icon-box">
                              <i class="fas fa-user"></i>
                            </div>
                            {{ i === 0 ? "Başvuru Yapan Kişi" : "Aile Üyesi #" + i }}
                          </button>
                          <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                              <ng-template>
                                <div class="applicant-form mb-2">
                                  <div class="flex-left-group">
                                    <div class="d-flex right">
                                      <div class="icon-box">
                                        <!-- <button
                                          type="submit"
                                          title="Pasaport Tara"
                                          data-placement="top"
                                          data-toggle="tooltip"
                                          class="btn btn-fav"
                                          data-original-title="Pasaport Tara"
                                          (click)="openFileDialog('passportFile', i)"
                                        >
                                          <i class="fa-solid fa-barcode"></i>
                                        </button>
                                      </div>
                                      <div class="icon-box mr-2">
                                        <button
                                          type="submit"
                                          title="Kimlik resmi yükle"
                                          data-placement="top"
                                          data-toggle="tooltip"
                                          class="btn btn-fav"
                                          data-original-title="Pasaport Tara"
                                          (click)="openFileDialog('personel-photo', i)"
                                        >
                                          <i class="fa fa-image"></i>
                                        </button> -->
                                      </div>
                                      <ng-container *ngIf="i != 0">
                                        <span>
                                          <i class="fa-solid fa-trash" style="cursor: pointer" (click)="deleteMember(i)"></i>
                                        </span>
                                      </ng-container>
                                    </div>
                                  </div>
                                  <p class="text-danger" style="font-size:15px">Başvurunuz için biyometrik fotoğraf yüklemeniz gerekmektedir. Fotoğrafınızın biyometrik standartlara uygun olduğundan emin olunuz.</p>
                                  <div class="hole-container">
                                    <div class="col-12 col-md-3" (click)="openFileDialog('personel-photo', i)">
                                      <label>Fotoğraf yükle</label>
                                      <div class="preview-image-container">
                                        <img
                                          [src]="customer.get('personalImage')?.value !== '' ? customer.get('personalImage')?.value : '/assets/images/biometric.png'"
                                          alt="Preview"
                                          class="preview-image-2"
                                        />
                                      </div>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('personalImage')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>

                                    <div class="col-12 col-md-3" (click)="openFileDialog('passportFile', i)">
                                      <label>Pasaport yükle</label>
                                      <div class="preview-image-container">
                                        <img
                                          [src]="customer.get('mainPassportImage')?.value !== '' ? customer.get('mainPassportImage')?.value : '/assets/images/passport3.png'"
                                          alt="Preview"
                                          style="height: 100%; object-fit: contain"
                                          class="preview-image-2"
                                        />
                                        <div class="input"></div>
                                      </div>
                                    </div>
                                    <p id="MRZ" hidden></p>
                                    <div class="col-12 col-md-6" style="display: flex; align-items: center">
                                      <p [innerText]="customer.get('mRZCode')?.value" style="overflow-wrap: anywhere; font-size: 16px"></p>
                                    </div>
                                  </div>
                                  <input
                                    (change)="onFileSelected($event, 'passportFile', i)"
                                    type="file"
                                    #photoooInput
                                    hidden
                                    id="photooo"
                                    name="passportFile"
                                    [class]="'photooo' + i"
                                    accept="image/*"
                                  />
                                  <input class="hidden-file-input" type="file" name="personel-photo" id="personel-photo" (change)="onFileSelected($event, 'personel-photo', i)" accept="image/*" />

                                  <!-- Diğer form alanları -->
                                  <div class="form-row">
                                    <div class="form-group col-md-3">
                                      <label>Pasaport No</label>
                                      <input id="PasaportNo" type="text" class="form-control" formControlName="passport_No" />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('passport_No')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>T.C. Kimlik Numarası</label>
                                      <input maxlength="11" (input)="onTCNumberChange($event, i)" id="TCNumber" type="text" class="form-control" formControlName="tC_Number" />
                                      <div>
                                        <small class="text-danger" *ngIf="(isSubmitForm || customer.get('tC_Number')?.touched) && customer.get('tC_Number')?.errors?.['required'] && customer.get('nationalityId')?.value === 792">{{ errors.required }}</small>
                                        <small class="text-danger" *ngIf="customer.get('tC_Number')?.errors?.['tcknInvalid'] && customer.get('nationalityId')?.value === 792">Geçersiz TC kimlik numarası!</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Uyruk</label>
                                      <select class="form-control" formControlName="nationalityId" (change)="onNationalityChange(i)">
                                        <ng-container *ngFor="let item of countries">
                                          <option [ngValue]="item.country.id">
                                            {{ item.name }}
                                          </option>
                                        </ng-container>
                                      </select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('nationality')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Doğum Yeri</label>
                                      <input (input)="ConvertToUpper($event)" type="text" class="form-control" formControlName="birthPlace" />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('birthPlace')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="form-row">
                                    <div class="form-group col-md-3">
                                      <label>Doğum Ülkesi</label>
                                      <ng-select
                                        [items]="countries"
                                        [bindLabel]="'name'"
                                        [bindValue]="'country.id'"
                                        [searchable]="true"
                                        [clearable]="false"
                                        placeholder="Ülke seçiniz"
                                        formControlName="birthCountryId"
                                        class="form-control custom-ng-select"
                                      >
                                      </ng-select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('birthCountryId')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Ad</label>
                                      <input (input)="ConvertToUpper($event)" id="firstName" type="text" class="form-control" formControlName="firstName" />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('firstName')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Soyad</label>
                                      <input (input)="ConvertToUpper($event)" id="lastName" type="text" class="form-control" formControlName="lastName" />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('lastName')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Cinsiyet</label>
                                      <select id="sex" class="form-control" formControlName="gender">
                                        <option value="">Seçiniz</option>
                                        <option [ngValue]="1">Erkek</option>
                                        <option [ngValue]="2">Kadın</option>
                                      </select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('gender')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="form-row">
                                    <div class="form-group col-md-3">
                                      <label>Medeni Durum</label>
                                      <select class="form-control" formControlName="maritalStatusId">
                                        <ng-container *ngFor="let item of maritalStatuses">
                                          <option [ngValue]="item.id">
                                            {{ item.name }}
                                          </option>
                                        </ng-container>
                                      </select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('maritalStatusId')?.errors?.['min']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Doğum Tarihi</label>
                                      <input type="date" id="birthDate" class="form-control" formControlName="birthDate" style="cursor: pointer" (change)="onBirthDateChange(i)" #dateInput1 (click)="openDatePicker(dateInput1)" />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('birthDate')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Pasaport Veriliş Tarihi</label>
                                      <input
                                        type="date"
                                        class="form-control"
                                        [max]="getTodayDate()"
                                        formControlName="dateOfIssue"
                                        style="cursor: pointer"
                                        #dateInput2
                                        (click)="openDatePicker(dateInput2)"
                                      />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('dateOfIssue')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Pasaport Bitiş Tarihi</label>
                                      <input
                                        type="date"
                                        id="expirationDate"
                                        class="form-control"
                                        formControlName="dateOfExpiry"
                                        #dateInput3
                                        (click)="openDatePicker(dateInput3)"
                                        style="cursor: not-allowed"
                                      />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('dateOfExpiry')?.errors?.['required']">{{ errors.required }}</small>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('dateOfExpiry')?.errors?.['dateInPast']">{{ errors.dateInPast }}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="form-row">
                                    <div class="form-group col-md-3">
                                      <label>Geldiği Ülke</label>
                                      <ng-select
                                        [items]="countries"
                                        [bindLabel]="'name'"
                                        [bindValue]="'country.id'"
                                        [searchable]="true"
                                        [clearable]="false"
                                        placeholder="Ülke seçiniz"
                                        formControlName="comingFromId"
                                        class="form-control custom-ng-select"
                                      >
                                      </ng-select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('comingFromId')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Veren Makam</label>
                                      <input (input)="ConvertToUpper($event)" type="text" id="issuingState" class="form-control" formControlName="passportIssuePlace" />
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('passportIssuePlace')?.errors?.['required']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Meslek</label>
                                      <select class="form-control" formControlName="professionId">
                                        <ng-container *ngFor="let item of professions">
                                          <option [ngValue]="item.id">
                                            {{ item.name }}
                                          </option>
                                        </ng-container>
                                      </select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('professionId')?.errors?.['min']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Eğitim Durumu</label>
                                      <select class="form-control" formControlName="educationId">
                                        <ng-container *ngFor="let item of educations">
                                          <option [ngValue]="item.id">
                                            {{ item.name }}
                                          </option>
                                        </ng-container>
                                      </select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('educationId')?.errors?.['min']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Dil</label>
                                      <select class="form-control" formControlName="visaLanguageId">
                                        <ng-container *ngFor="let item of languages">
                                          <option [ngValue]="item.id">
                                            {{ item.name }}
                                          </option>
                                        </ng-container>
                                      </select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('visaLanguageId')?.errors?.['min']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                      <label>Din</label>
                                      <select class="form-control" formControlName="religionId">
                                        <ng-container *ngFor="let item of religions">
                                          <option [ngValue]="item.id">
                                            {{ item.name }}
                                          </option>
                                        </ng-container>
                                      </select>
                                      <div>
                                        <small class="text-danger" *ngIf="isSubmitForm && customer.get('religionId')?.errors?.['min']">{{ errors.required }}</small>
                                      </div>
                                    </div>
                                    <!-- Aile Üyeliği Seçimi -->
                                    <div class="form-group col-md-3" *ngIf="form.controls['applicationType'].value == 2">
                                      <div class="form-group">
                                        <label class="text-nowrap mr-2" style="align-content: center; position: relative; top: 0">Aile Üyeliği</label>
                                        <select class="form-control" formControlName="familyMemberType">
                                          <ng-container *ngFor="let item of familyMemberTypes">
                                            <option [ngValue]="item.id">
                                              {{ item.name }}
                                            </option>
                                          </ng-container>
                                        </select>
                                        <div>
                                          <small class="text-danger" *ngIf="isSubmitForm && customer.get('familyMembershipId')?.errors?.['required']">{{ errors.required }}</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Diğer Belgeler -->
                                  <div *ngIf="!hideHotelAndTicket" class="form-row col-12 col-md-12 file-upload">
                                    <h6>
                                      <i class="fa-solid fa-circle-info" style="margin-right: 5px"></i>Lüften vize başvurusu için uçak biletini ve konaklamaya ait otel bilgisini sisteme yükleyiniz.
                                    </h6>
                                    <div class="form-group col-md-12">
                                      <div class="row">
                                        <!-- Konaklama Belgesi -->
                                        <div class="col-md-6">
                                          <div
                                            class="file-upload-container d-flex align-items-center"
                                            style="position: relative; cursor: pointer; min-height: 90px; padding: 12px 18px"
                                            (click)="openFileDialog('hotel-file', i)"
                                          >
                                            <div style="margin-right: 24px; display: flex; align-items: center; height: 56px">
                                              <img src="/assets/images/hotel.png" alt="Hotel Icon" style="height: 50px; width: 50px; object-fit: contain" />
                                            </div>
                                            <div class="upload-text" [id]="'hotel-text-' + i" style="font-size: 1.1rem">Konaklama Belgesi</div>
                                            <a class="abss-btn" *ngIf="checkShow('hotel-file', i)" (click)="[$event.stopPropagation(), openPreviewImageModal('hotel-file', i)]">Göster</a>
                                            <input class="hidden-file-input" type="file" accept=".pdf,image/*" name="hotel-file" id="hotel-file" (change)="onFileSelected($event, 'hotel-file', i)" />

                                          </div>
                                           <div>
                                              <small class="text-danger" *ngIf="isSubmitForm && customer.get('hotelReservationUrl')?.errors?.['required']">{{ errors.required }}</small>
                                            </div>
                                        </div>
                                        <!-- Dönüş Bileti -->
                                        <div class="col-md-6">
                                          <div
                                            class="file-upload-container d-flex align-items-center"
                                            style="position: relative; cursor: pointer; min-height: 90px; padding: 12px 18px"
                                            (click)="openFileDialog('returnTicket', i)"
                                          >
                                            <div style="margin-right: 24px; display: flex; align-items: center; height: 56px">
                                              <img src="assets/images/airplane-ticket.png" alt="Airplane Ticket Icon" style="height: 50px; width: 50px; object-fit: contain" />
                                            </div>
                                            <div class="upload-text" [id]="'return-text-' + i" style="font-size: 1.1rem">Dönüş Bileti</div>
                                            <a class="abss-btn" *ngIf="checkShow('returnTicket', i)" (click)="[$event.stopPropagation(), openPreviewImageModal('returnTicket', i)]">Göster</a>
                                            <input class="hidden-file-input" type="file" accept=".pdf,image/*" name="returnTicket" id="returnTicket" (change)="onFileSelected($event, 'returnTicket', i)" />


                                          </div>
                                             <div>
                                              <small class="text-danger" *ngIf="isSubmitForm && customer.get('returnTicketUrl')?.errors?.['required'] && selectedCountry?.id !== 51">{{ errors.required }}</small>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Aile üyesi ekleme butonu -->
                    <div *ngIf="form.controls['applicationType'].value == '2'" class="text-right" style="padding: 10px">
                      <button type="button" class="add-member-btn" (click)="addMember()"><i class="fa-solid fa-user-plus"></i>{{customers.length + 1}}. Kişiyi Ekle</button>
                    </div>
                  </div>
                </div>
              </div>
              <a type="button" class="btn-deneme mt-4" (click)="continue()"> Kaydet ve İlerle <i class="fa-solid fa-arrow-right"></i> </a>
            </div>
          </div>

          <!-- <button (click)="show(showTypes.payment)"></button> -->
          <!-- Step 2 - İletişim ve Ödeme -->
          <div class="step-2-container">
            <!-- İletişim Bilgileri -->

            <ng-template #contactModal let-modal>
              <div class="modal-content">
                <div class="modal-header">
                  <!-- <h4 class="modal-title" id="modal-basic-title">Hi there!</h4> -->
                  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="contact-section">
                    <div class="contact-section">
                      <div class="application-section">
                        <div class="form-title">
                          <h6>İLETİŞİM BİLGİLERİ</h6>
                        </div>
                        <div class="section-content">
                          <div class="section-body">
                            <div class="form-container">
                              <label class="section-txt">Size daha iyi bir hizmet sunabilmemiz için lütfen iletişim kurulacak kişiyi seçiniz.</label>
                              <div class="select-box">
                                <select id="contactPerson" formControlName="contactCustomerPassport_No">
                                  <!-- <option value="" disabled [selected]="contactPersons.length != 1">
                                İletişim Kurulacak Kişi
                              </option> -->

                                  <option *ngFor="let person of contactPersons" [ngValue]="person.contactCustomerPassport_No">{{ person.firstName }} {{ person.lastName }}</option>
                                </select>
                              </div>
                              <label class="section-txt">Size daha iyi bir hizmet sunabilmemiz için lütfen ikamet edilen ili seçiniz .<span class="text-danger">*</span></label>
                              <div class="select-box">
                                <select id="marka" formControlName="cityId">
                                  <ng-container *ngFor="let city of cities">
                                    <option [ngValue]="city.id">
                                      {{ city.name }}
                                    </option>
                                  </ng-container>
                                </select>
                              </div>
                              <div class="form-group mt-3" style="margin-bottom:0px">
                                <label>Telefon Numarası<span class="text-danger">*</span></label>
                                <input
                                  type="text"
                                  id="phoneNumber"
                                  [textMask]="{ mask: mask10 }"
                                  name="phoneNumber"
                                  formControlName="phoneNumber"
                                  class="form-control phone-mask"
                                  placeholder="(5XX) XXX-XXXX"
                                />
                                <div>
                                  <small class="text-danger" *ngIf="isSubmitForm && form.controls['phoneNumber']?.errors?.['phoneNumberInvalid']">{{ errors.phoneNumber }}</small>
                                </div>
                              </div>
                              <div class="form-group mt-3" style="margin-bottom:0px">
                                <label>E-posta <span class="text-danger">*</span></label>
                                <input style="padding: 0.375rem 0.75rem" type="email" id="email" name="email" class="form-control" formControlName="email" placeholder="ornek@email.com" />
                              </div>
                            </div>

                            <div class="">
                              <div class="form-check mt-3">
                                <input class="form-check-input" type="checkbox" id="flexCheckDefault" formControlName="kvkk" />
                                <label class="form-check-label kvkk-text" for="flexCheckDefault"
                                  ><a target="_blank" href="/politikalar-ve-kvkk-dokumanlari/aydinlatma-metni">KVKK şartlarını</a> okudum , onaylıyorum.
                                </label>
                              </div>
                              <small class="text-danger" *ngIf="isSubmitForm && form.controls['kvkk']?.errors?.['required']">{{ errors.required }}</small>
                            </div>

                            <div class="flex-group">
                              <a type="button" class="btn-deneme mt-4" (click)="goBack()"
                                ><i style="margin-right: 7px" class="fa-solid fa-arrow-left"></i>
                                Geri Dön
                              </a>
                              <a type="button" class="btn-deneme mt-4" (click)="saveAndContinue()">
                                Kaydet ve İlerle
                                <i class="fa-solid fa-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <!-- Ödeme Bilgileri -->
            <div *ngIf="showType == showTypes.payment" class="payment-section pay2">
              <div class="application-section">
                <div class="form-title">
                  <h6>ÖDEME BİLGİLERİ</h6>
                </div>
                <div class="payment-section">
                  <div class="row payrow" *ngIf="!showPaymentSection">
                    <div class="col-12 col-md-8">
                      <div class="fatura-bilgisi">
                        <h6>Fatura Bilgileri</h6>
                        <div class="f-box">
                          <label style="font-weight: bold">Fatura Türü</label>
                          <!-- Fatura Türü Seçimi -->
                          <div class="form-group form-checkbox-fatura">
                            <div class="form-check">
                              <input class="form-check-input" type="radio" id="individualInvoice" [checked]="invoiceType == 0 ? 'checked' : ''" name="invoiceType" (change)="checkType(0)" />
                              <label class="form-check-label" for="individualInvoice"> Bireysel </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="radio" id="corporateInvoice" name="invoiceType" [checked]="invoiceType == 1 ? 'checked' : ''" (change)="checkType(1)" />
                              <label class="form-check-label" for="corporateInvoice"> Kurumsal </label>
                            </div>
                          </div>

                          <div>
                            <label style="font-weight: bold"> Fatura bilgileri</label>

                            <div class="row" *ngIf="invoiceType == 0">
                              <div class="form-group col-md-6">
                                <label for="firstName">Ad<span class="text-danger">*</span></label>
                                <input (input)="ConvertToUpper($event)" type="text" id="firstName" class="form-control" formControlName="invoice_FirstName" placeholder="Adınızı giriniz" />
                              </div>
                              <div class="form-group col-md-6">
                                <label for="lastName">Soyad<span class="text-danger">*</span></label>
                                <input (input)="ConvertToUpper($event)" type="text" id="lastName" class="form-control" formControlName="invoice_LastName" placeholder="Soyadınızı giriniz" />
                              </div>
                            </div>

                            <div class="row">
                              <div class="form-group col-md-6" *ngIf="invoiceType == 0">
                                <label for="title">TC Kimlik Numarası<span class="text-danger">*</span></label>
                                <input
                                  maxlength="11"
                                  (input)="onInvoiceTCNumberChange($event)"
                                  type="text"
                                  id="title"
                                  class="form-control"
                                  formControlName="invoice_TCNumber"
                                  placeholder="TC Kimlik numaranızı giriniz"
                                />
                                <div>
                                  <small class="text-danger" *ngIf="(isSubmitForm || form.get('invoice_TCNumber')?.touched) && form.get('invoice_TCNumber')?.errors?.['required'] && customers.at(0)?.get('nationalityId')?.value === 792">{{ errors.required }}</small>
                                  <small class="text-danger" *ngIf="form.get('invoice_TCNumber')?.errors?.['tcknInvalid'] && customers.at(0)?.get('nationalityId')?.value === 792">Geçersiz TC kimlik numarası!</small>
                                </div>
                              </div>
                              <div class="form-group col-md-6" *ngIf="invoiceType == 1">
                                <label for="title">Ünvan<span class="text-danger">*</span></label>
                                <input type="text" (input)="ConvertToUpper($event)" id="title" class="form-control" formControlName="invoice_Title" placeholder="Ünvanınızı giriniz" />
                              </div>
                              <div class="form-group col-md-6">
                                <label for="address">Adres<span class="text-danger">*</span></label>
                                <textarea (input)="ConvertToUpper($event)" id="address" class="form-control" formControlName="invoice_Address" placeholder="Adresinizi giriniz"></textarea>
                              </div>
                            </div>

                             <div class=" row">
                               <div class=" select-boxInvoice form-group col-md-6">
                                  <label for="invoiceCity">İl<span class="text-danger">*</span></label>
                                <select id="invoiceCity" formControlName="invoice_City">
                                   <option value="" disabled selected>İl seçiniz</option>
                                  <ng-container *ngFor="let city of cities">
                                    <option [ngValue]="city.name">
                                      {{ city.name }}
                                    </option>
                                  </ng-container>
                                </select>
                              </div>
                              <div class=" form-group col-md-6">
                                <label for="invoiceDistrict">İlçe<span class="text-danger">*</span></label>
                                <input type="text" id="invoiceDistrict" class="form-control" formControlName="invoice_District" placeholder="İlçe giriniz" />
                              </div>
                              </div>
                            <div class="row" *ngIf="invoiceType == 1">
                              <div class="form-group col-md-6">
                                <label for="taxOffice">Vergi Dairesi<span class="text-danger">*</span></label>
                                <input type="text" id="taxOffice" class="form-control" formControlName="invoice_TaxOffice" placeholder="Vergi dairesini giriniz" />
                              </div>
                              <div class="form-group col-md-6">
                                <label for="taxNumber">Vergi No<span class="text-danger">*</span></label>
                                <input
                                  (input)="formatNumberInput($event)"
                                  maxlength="10"
                                  type="text"
                                  id="taxNumber"
                                  class="form-control"
                                  formControlName="invoice_TaxNumber"
                                  placeholder="Vergi numarasını giriniz"
                                />
                              </div>
                            </div>

                            <div class="row" *ngIf="form.get('sendCargo')?.value">
                              <div class="form-group col-12">
                                <label for="deliveryAddress">Teslimat Adresi</label>
                                <textarea formControlName="deliveryAddress" type="text" id="deliveryAddress" class="form-control" placeholder="Teslimat Adresi Giriniz"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-4">
                      <div class="fatura-bilgisi">
                        <h6>Ödeme Özeti</h6>
                        <div class="payment-summary">
                          <p class="odemebilgi">Vize Ücreti : {{ visaPrice | currency : " $" }}</p>
                          <p class="odemebilgi" *ngIf="form.get('sendSMS')?.value === true">Sms Hizmet Bedeli : {{ smsPrice | currency : " $" }}</p>
                          <p class="odemebilgi" *ngIf="form.get('sendCargo')?.value === true">Kargo Gönderim Ücreti : {{ cargoPrice | currency : " $" }}</p>
                          <span>
                            <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-direction: column">
                              <b class="resultPriceLable" style="font-size: 20px"> Tutar(USD): {{ resultPrice | currency : " $" }}</b>
                              <b class="resultPriceLable" style="font-size: 20px"> Tutar(TRY): {{ resultPriceTRY | currency : " ₺" }}</b>
                            </div>
                            <div class="form-check mt-3">
                              <input class="form-check-input" type="checkbox" id="smsCheckbox" formControlName="sendSMS" (change)="getPriceByGuid()" />
                              <label class="form-check-label" for="smsCheckbox"> SMS ile bilgilendirme almak istiyorum </label>
                            </div>
                            <div class="form-check mt-3">
                              <input class="form-check-input" type="checkbox" id="cargoCheckbox" formControlName="sendCargo" (change)="getPriceByGuid()" />
                              <label class="form-check-label" for="cargoCheckbox"> Vizeyi evime kargolatmak istiyorum</label>
                            </div>
                            <div class="form-check mt-3">
                              <input (change)="setOneTimePaymentApproval()" class="form-check-input" type="checkbox" formControlName="oneTimePaymentApproval" id="oneTimePaymentApproval" />
                              <label class="form-check-label" for="oneTimePaymentApproval"
                                ><a target="_blank" href="/politikalar-ve-kvkk-dokumanlari/hukum-ve-kosullar">Mesafeli Satış Sözleşmesini</a> okudum, onaylıyorum</label
                              >
                            </div>

                            <small class="text-danger" *ngIf="isSubmitForm && form.controls['oneTimePaymentApproval']?.errors?.['requiredTrue']">{{ errors.required }}</small>
                          </span>

                          <!-- Tek seferlik ödeme onayı -->
                        </div>
                        <div>
                          <button type="submit" class="btn-deneme2 mt-4" (click)="updateInvoice()">Kaydet ve Ödeme Yap</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="showPaymentSection" class="showPaymentSection" style="margin-bottom: 10px">
                    <div class="">
                      <button type="button" class="btn-update-invoice" (click)="reUpdateInvoice()">
                        Fatura Bilgileri Güncelle
                        <!-- // edit Icon -->
                        <i class="fa-solid fa-pen-to-square"></i>
                      </button>
                      <!-- // geri dönüş butonu -->
                    </div>
                  </div>
                  <div class="pay-tab" *ngIf="showPaymentSection">
                    <div class="tabs">
                      <ul class="tabs-nav">
                        <li [class]="paymentType === 'creditCard' ? 'tab-active' : ''">
                          <a (click)="selectPaymentType('creditCard')">Kredi Kartı ile Ödeme</a>
                        </li>
                        <li [class]="paymentType === 'transfer' ? 'tab-active' : ''">
                          <a (click)="selectPaymentType('transfer')">Havale ile Ödeme</a>
                        </li>
                      </ul>
                      <div class="tabs-stage">
                        <ng-container *ngIf="paymentType === 'creditCard'">
                          <div class="tabcontent kredit-payment" id="tab-1">
                            <div class="row align-items-center">
                              <!-- Kart Önizlemesi -->
                              <div class="col-12 col-md-6 mb-3 mb-md-0">
                                <div class="card-preview" [class.flipped]="isCardFlipped">
                                  <div class="card-inner">
                                    <div class="card-front">
                                      <div class="card-bg">
                                        <div id="card-icon" style="height: 40px"></div>
                                        <div class="card-number">
                                          {{ credit_card_no || "•••• •••• •••• ••••" }}
                                        </div>
                                        <div class="card-info">
                                          <div class="card-holder">
                                            <span class="label">Kart Sahibi</span>
                                            <span class="value">{{ cc_holder_name || "AD SOYAD" }}</span>
                                          </div>
                                          <div class="card-expires">
                                            <span class="label">Son Kullanma</span>
                                            <span class="value">{{ expiry_month || "MM" }}/{{ expiry_year || "YY" }}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="card-back">
                                      <div class="card-bg">
                                        <div class="card-stripe"></div>
                                        <div class="card-cvv">
                                          <span class="label">CVV</span>
                                          <div class="cvv-band">
                                            {{ cvv || "•••" }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Kart Bilgi Formu -->
                              <div class="col-12 col-md-6">
                                <div class="card-form">
                                  <div class="form-group">
                                    <label>Kart Üzerindeki İsim</label>
                                    <input
                                      type="text"
                                      autocomplete="cc-name"
                                      (input)="formatCardHolder($event)"
                                      class="form-control"
                                      placeholder="Kart sahibinin adı"
                                      (focus)="isCardFlipped = false"
                                    />
                                  </div>
                                  <div class="form-group">
                                    <label>Kart Numarası</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      autocomplete="cc-number"
                                      placeholder="1234 5678 9012 3456"
                                      (focus)="isCardFlipped = false"
                                      maxlength="19"
                                      (input)="formatCardNumber($event)"
                                    />
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <label>Son Kullanma Tarihi</label>
                                        <div class="d-flex gap-2">
                                          <select autocomplete="cc-exp-month" class="form-control" (focus)="isCardFlipped = false" (change)="onMonthChange($event)">
                                            <option value="" disabled selected>Ay</option>
                                            <option *ngFor="let month of months" [value]="month">
                                              {{ month.padStart(2, "0") }}
                                            </option>
                                          </select>
                                          <select autocomplete="cc-exp-year" class="form-control" (focus)="isCardFlipped = false" (change)="onYearChange($event)">
                                            <option value="" disabled selected>Yıl</option>
                                            <option *ngFor="let year of years" [value]="year">
                                              {{ year }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <label>CVV</label>
                                        <input
                                          autocomplete="cc-csc"
                                          (input)="formatNumberInput($event, 'cvv')"
                                          type="text"
                                          class="form-control"
                                          placeholder="123"
                                          maxlength="3"
                                          (focus)="isCardFlipped = true"
                                          (blur)="isCardFlipped = false"
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-12">
                                      <button type="button" class="btn-deneme2 okPayments mt-4" [disabled]="!paymentType" (click)="processPayment()">Ödeme Yap</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="paymentType === 'transfer'">
                          <div class="tabcontent" id="tab-2">
                            <div class="application-number-simple mb-3">
                              <div class="appliacationAndPayment">
                                <div class="application-label">Başvuru No: #{{ form.get("apllicationNumber")?.value }}</div>

                                <div class="col-12 col-sm-6 col-md-4 odenecektutar mt-3">
                                  ÖDENECEK TUTAR:
                                  <span
                                    ><b>{{ resultPrice | currency : " $" }} </b></span
                                  >
                                </div>
                              </div>
                            </div>

                            <div class="bank">
                              <div class="col-12 col-md-5 alert transfer-alert bank-card" *ngFor="let bank of banks">
                                <div class="bank-info-row">
                                  <span class="bank-label">Banka Adı :</span>
                                  <span class="bank-value">{{ bank.bankaAdi }}</span>
                                </div>
                                <div class="bank-info-row">
                                  <span class="bank-label">Şube Kodu:</span>
                                  <span class="bank-value">{{ bank.subeKodu }}</span>
                                </div>
                                <div class="bank-info-row">
                                  <span class="bank-label">IBAN:</span>
                                  <span class="bank-value">{{ bank.iban }}</span>
                                </div>
                                <div class="bank-info-row">
                                  <button class="copy-btn btn--sm" (click)="copyToClipboard(bank.iban)">Kopyala</button>
                                </div>
                              </div>
                            </div>
                            <div class="bank-infos">
                              Havale/EFT ile işlemlerinizde alıcı adını ' <b> {{ contact.companyName }}</b> ' olarak girmelisiniz. Lütfen açıklama kısmına <b>başvuru numaranızı</b> yazmayı
                              unutmayınız.
                            </div>
                          </div>
                          <div class="text-center mt-3">
                            <!-- <button type="button" class="btn-deneme2 mt-4" (click)="processTransferPayment()">Ödeme Yapıldı</button> -->
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- başvuru sonuç -->
            <div *ngIf="showType == showTypes.result" class="result-section application-section row">
              <div class="pay-pic col-md-3" style="max-width: 450px">
                <img src="../../../assets/images/pic.PNG" />
              </div>
              <div class="col-md-8">
                <div class="section-content">
                  <div class="result-content">
                    <p class="result-text">
                      Başvuru numaranız:
                      <span class="application-number"> #{{ visaApplicationNumber }} </span>
                    </p>
                  </div>

                  <!-- Başvuru  Numarası -->
                  <div class="result-content">
                    <p><i class="fa fa-check"></i></p>
                    <p>
                      Sayın
                      <span>{{ contactPerson.firstName + " " + contactPerson.lastName }}</span>
                    </p>
                    <p>Başvurunuz başarıyla tamamlanmıştır!</p>
                    <div class="mail-text">
                      <span>Tarafınıza bir e-posta gönderilmiştir.</span>
                      <span>Lütfen e-postayı kontrol ediniz. Spam/junk klasörünüzü de gözden geçirmeyi unutmayınız.</span>
                    </div>
                  </div>
                  <!-- //Başvuru  Numarası -->
                </div>
                <div class="visa-application-result">
                  <div class="result-content">
                    <p>Vize Türü</p>
                    <span>{{ selectedVisitReason.name }}</span>
                  </div>

                  <div class="result-content">
                    <p>Vize Süresi</p>
                    <span>{{ selectedVisaType.name }}</span>
                  </div>

                  <div class="result-content">
                    <p>Öncelik</p>
                    <span>{{ selectedLevel.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal İçeriği -->
  <ng-template #pasaportModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">İçeriğe Göre Modal</h4>
        <button type="button" class="btn-close" (click)="modal.dismiss()">X</button>
      </div>
      <div class="modal-body">
        <app-pasaport-modal *ngIf="showType == showTypes.form"></app-pasaport-modal>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeModal(modal, customerIndex)">Onaylıyorum</button>
      </div>
    </div>
  </ng-template>
  <ng-template #previewImageModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Image Modal</h4>
        <button type="button" class="btn-close" (click)="closePreviewImageModal()">X</button>
      </div>
      <div class="modal-body">
        <ngx-extended-pdf-viewer *ngIf="pdfPreview != ''" [src]="pdfPreview" [textLayer]="true" [height]="'auto'"></ngx-extended-pdf-viewer>
        <div class="flex-center">
          <img *ngIf="imagePreview !== ''" [src]="imagePreview" alt="imagePreview" style="max-width: 22rem; height: auto; object-fit: cover" />
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger" (click)="closePreviewImageModal()">Kapat</button>
      </div>
    </div>
  </ng-template>

  <ng-template #paymentModal let-modal>
    <div class="modal-content" style="height: 100%">
      <div class="modal-body">
        <iframe #iframeRef id="payment-frame" name="payment-frame" style="width: 100%; border: none; height: 35rem; display: block"></iframe>
        <div id="form-wrapper" style="display: none"></div>
      </div>
      <div class="modal-footer">
        <!-- <button class="btn btn-danger" (click)="closePreviewImageModal()">Kapat</button> -->
      </div>
    </div>
  </ng-template>
  <!-- <ngx-extended-pdf-viewer
    [src]="pdfPreview != '' ? pdfPreview : ''"
    [height]="'auto'"
  ></ngx-extended-pdf-viewer> -->
</div>
